import { createSharedComposable } from '@vueuse/core';
import FieldManagerDialog from '@/presentation/components/FieldManager/FieldManagerDialog.vue';
import ColumnManageDialog from '@/presentation/components/FieldManager/ColumnManageDialog.vue';
import SynapseColumnMangeDialog from '@/presentation/components/FieldManager/SynapseColumnMangeDialog.vue';
import { useDialog } from '@/presentation/composables/use-dialog';
import { DataType } from '@/domains/base/enums/data-type';
import { useDetailRoute } from '../../composables/use-detail-route';
import { useFeatureConfig } from '@/presentation/composables/common/use-feature-config';
import { useRaven } from '@/presentation/composables/use-raven';
import { useDetailRouter } from '../../composables/use-detail-router';
import { create } from '@patsnap/tahiti-core/utils/deferred';
export const useFieldSettingDialog = createSharedComposable(() => {
    const { createDialog } = useDialog();
    const { dataType } = useDetailRoute();
    const { synapseHiddenKey } = useFeatureConfig();
    const { rvTrack } = useRaven();
    const { refreshPage } = useDetailRouter();
    const COMPONENT_VIEW_TYPE_MAP = {
        [DataType.PATENT]: {
            component: FieldManagerDialog,
            props: {},
        },
        [DataType.PAPER]: {
            component: ColumnManageDialog,
            props: {},
        },
        [DataType.MARKET]: {
            component: ColumnManageDialog,
            props: {},
        },
        [DataType.MERGER]: {
            component: ColumnManageDialog,
            props: {},
        },
        [DataType.INVESTMENT]: {
            component: ColumnManageDialog,
            props: {},
        },
        [DataType.DRUG]: {
            component: SynapseColumnMangeDialog,
            props: {
                fixedKey: 'DRUG_ID',
                hiddenKey: synapseHiddenKey,
            },
        },
        [DataType.CLINICAL]: {
            component: SynapseColumnMangeDialog,
            props: {
                fixedKey: 'REGISTER_NUMBER',
            },
        },
        [DataType.CLINICAL_RESULT]: {
            component: SynapseColumnMangeDialog,
            props: {
                fixedKey: 'BRIEF_TITLE',
            },
        },
    };
    let dialogInstance = null;
    function openVisibleFieldSettingDialog(tab) {
        if (dialogInstance)
            return;
        const Component = COMPONENT_VIEW_TYPE_MAP[dataType.value].component;
        const props = COMPONENT_VIEW_TYPE_MAP[dataType.value].props;
        const deferred = create();
        dialogInstance = createDialog(Component, {
            ...props,
            tab,
            close() {
                dialogInstance?.close();
                dialogInstance = null;
                deferred.reject('Cancel');
            },
            apply() {
                dialogInstance?.close();
                dialogInstance = null;
                refreshPage();
                deferred.resolve('Success');
            },
        });
        dialogInstance.show();
        rvTrack('Click Manage Fields Button');
        return deferred.promise;
    }
    return {
        openVisibleFieldSettingDialog,
    };
});
